"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var index_1 = __importDefault(require("@components/Modal/index"));
var Button_1 = __importStar(require("@components/Button"));
var react_i18next_1 = require("react-i18next");
var sanitize_1 = require("@utils/sanitize");
function ConfirmDelete(props) {
    var onDelete = props.onDelete, isOpen = props.isOpen, setIsOpen = props.setIsOpen, title = props.title, text = props.text;
    var t = (0, react_i18next_1.useTranslation)().t;
    // When you add an event listener, it captures the state at the time of its definition and doesn't automatically update when the state changes.
    var isOpenRef = (0, react_1.useRef)(isOpen);
    var onDeleteRef = (0, react_1.useRef)(onDelete);
    (0, react_1.useEffect)(function () {
        isOpenRef.current = isOpen;
    }, [isOpen]);
    (0, react_1.useEffect)(function () {
        onDeleteRef.current = onDelete;
    }, [onDelete]);
    var handleKeyDown = function (event) {
        if (event.key === 'Enter' && isOpenRef.current) {
            onDeleteRef.current();
            setIsOpen(false);
        }
    };
    (0, react_1.useEffect)(function () {
        document.addEventListener('keydown', handleKeyDown);
        return function () {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
    return (react_1.default.createElement(index_1.default, { isOpen: isOpen, setIsOpen: setIsOpen },
        react_1.default.createElement("div", { className: "delete-item-modal" },
            react_1.default.createElement("h3", { className: "delete-modal__title" }, title),
            react_1.default.createElement("p", { className: "delete-modal__text", dangerouslySetInnerHTML: { __html: (0, sanitize_1.evaSanitize)(text) } }),
            react_1.default.createElement("div", { className: "delete-modal__button-group" },
                react_1.default.createElement(Button_1.SecondaryButton, { text: t('AUTOMATION.LISTS.DELETE_POPOVER.CANCEL_BTN'), onClick: function () { return setIsOpen(false); } }),
                react_1.default.createElement(Button_1.default, { text: t('AUTOMATION.LISTS.DELETE_POPOVER.CONFIRM_BTN'), onClick: function () {
                        onDelete();
                        setIsOpen(false);
                    } })))));
}
exports.default = ConfirmDelete;
